import { SendMethod } from '@/features/extrajudicial/types';

export function getSendMethodLabel(method: SendMethod | '' | null | undefined): string {
  switch (method) {
    case SendMethod.DIGITAL:
      return 'Digital (E-mail + WhatsApp)';
    case SendMethod.EMAIL_APENAS:
      return 'Digital (E-mail apenas)';
    case SendMethod.WHATSAPP_APENAS:
      return 'Digital (WhatsApp apenas)';
    case SendMethod.SEDEX:
      return 'Físico (SEDEX)';
    case SendMethod.DIGITAL_SEDEX:
      return 'Digital + Físico (SEDEX)';
    default:
      return 'Não selecionado';
  }
}

export function getSendMethodShortLabel(method: SendMethod | '' | null | undefined): string {
  switch (method) {
    case SendMethod.DIGITAL:
      return 'E-mail + WhatsApp';
    case SendMethod.EMAIL_APENAS:
      return 'E-mail';
    case SendMethod.WHATSAPP_APENAS:
      return 'WhatsApp';
    case SendMethod.SEDEX:
      return 'SEDEX';
    case SendMethod.DIGITAL_SEDEX:
      return 'Digital + Físico';
    default:
      return 'Não definido';
  }
}

export function isPhysicalMethod(method: SendMethod | '' | null | undefined): boolean {
  return [SendMethod.SEDEX, SendMethod.DIGITAL_SEDEX].includes(method as SendMethod);
}
